
  import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
  import { Validations } from 'vuelidate-property-decorators';
  import { required, minValue, maxLength } from 'vuelidate/lib/validators';
  import { EventBus } from '@/event-bus';
  import { IEmployeeListModel, EmployeeListModel } from './EmployeeListModels';
  import {
    EnumModel,
    JobItemType,
    JobItemTypeEnums,
    JobItemTypeEnumsGeneric,
    EnumModelGeneric
  } from '@/common/enumerations';
  import { Client, EmployeeModel, EmployeeUpdateModel } from '@/services/api.service';
  import { EmployeeUpdatedMessage } from '@/services/eventbus.models';
  import toJobItemTypeFormatter from '@/filters/jobitemtype.formatter';
  import * as StringUtils from '@/utilities/string.utils';

  @Component({
    props: {
      employee: {
        type: Object as () => IEmployeeListModel,
        required: false
      },
      isInDialogMode: Boolean
    },
    filters: {
      toJobItemType: toJobItemTypeFormatter
    }
  })
  export default class EmployeeEdit extends Vue {
    private firstName: string = '';
    private lastName: string = '';
    private gid: string = '';
    private availableJobItemTypes: Array<EnumModelGeneric<JobItemType>> = [];
    private selectedJobItemTypes: Array<EnumModelGeneric<JobItemType>> = [];

    public formIsValid: boolean | null = null;

    @Validations()
    private validations = {
      firstName: { required },
      lastName: { required }
    };

    private mounted() {
      this.availableJobItemTypes.push(
        ...JobItemTypeEnumsGeneric.sort((n1, n2) => StringUtils.stringCompare(n1.name || '', n2.name || ''))
      );

      if (this.$props.employee) {
        this.firstName = this.$props.employee.firstName;
        this.lastName = this.$props.employee.lastName;
        this.gid = this.$props.employee.gid;
        this.selectedJobItemTypes = this.$props.employee.assignableJobItemTypes;
      }
    }

    private updateEmployee() {
      // Do the work here
      // Run the validation
      // @ts-ignore
      this.$v.$touch();
      const me = this;
      // @ts-ignore
      if (me.$v.$invalid) {
        this.formIsValid = false;
        console.log('Submit failed. Form is invalid.');
      } else {
        // do your submit logic here
        me.formIsValid = true;
        console.log('Submit started. Form valid.');
        const updateEmployee: EmployeeUpdateModel = new EmployeeUpdateModel();

        console.log(this.selectedJobItemTypes);
        updateEmployee.init({
          gid: this.gid,
          firstName: this.firstName,
          lastName: this.lastName,
          assignableJobItemTypes: this.selectedJobItemTypes,
          isDeleted: false
        });
        console.log(updateEmployee);
        const clientService: Client = new Client(process.env.VUE_APP_API_URL, this.$http);
        // @ts-ignore
        me.$Progress.start();
        clientService.updateEmployee(this.gid, updateEmployee).then((data: EmployeeModel) => {
          // Route to the edit job list screen?
          console.log('Returned employee:');
          console.log(data);
          // @ts-ignore
          me.$Progress.finish();
          // @ts-ignore
          me.$awn.success('Employee ' + me.firstName + ' ' + me.lastName + ' updated successfully');
          me.$emit('employee-updated', data);
          EventBus.$emit('employee-updated', new EmployeeUpdatedMessage(data));
          me.closeModal();
        });
      }
    }
    private cancelEdit() {
      console.log('Cancelling edit...');
      // this.$emit('close');
      this.closeModal();
    }

    private closeModal() {
      this.$modal.hide('modal-employee-edit');
    }
  }
